/**
 * Converts htmlString into nodeElement
 * @param {string} htmlString
 * @returns
 */
const createElementFromHTML = (htmlString) => {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstElementChild;
};

class ClerkSlider {
    constructor({ main }) {
        this.dom = {
            main: main
        }
        this.clerkSettings = JSON.parse(main.dataset.sectionSettings);
        this.clerkSettings.attributes = ['handle', 'id'];
        this.settings = {
            productClassString: 'Carousel__Cell product-item product-item--vertical 1/4--lap 1/5--desk 1/6--wide'
        }
        
        this.Search();
    }

    Init() {

        if (this.data != null) {
            this.Products();
        }
        else {
            this.dom.main.remove();
        }
    }

    Products() {
        let itemsLoaded = 0;
        this.data.product_data.forEach(async (product, i, array) => {

            const placeholder = createElementFromHTML(`    
            <div class="${ this.settings.productClassString }">
                <div class="loading-square">
                </div>
                <div class="loading-string loading-string__small"></div>
                <div class="loading-string"></div>
                <div class="loading-string loading-string__small"></div>
                <div class="loading-string loading-string__small"></div> 
            </div>
            `)

            this.dom.main.insertAdjacentElement('beforeEnd', placeholder);

            fetch(`/products/${ product.handle }?view=item`).then(data => {

                return data.text()

            }).then(htmlText => {

                const html = createElementFromHTML(htmlText)
                html.setAttribute('data-clerk-product-id', product.id)
                
                placeholder.replaceWith(html);
                
                itemsLoaded++;

                if (itemsLoaded === array.length) {
                    Clerk("click", "*[data-clerk-product-id]");
                    this.InitSlider()
                }

            });
        });
    }


    InitSlider() {
        const flickityOptions = JSON.parse(this.dom.main.getAttribute('data-flickity-config'));

        if(!flickityOptions) return 


        this.flickityInstance = new Flickity(this.dom.main, flickityOptions);

        var lastWidth = window.innerWidth;
        window.addEventListener('resize', () => {
            if (window.innerWidth !== lastWidth) {
                this.flickityInstance.resize();

                lastWidth = window.innerWidth;
            }
        }); // If the browser supports ResizeObserver we use it to detect when the size of the items in the carousel change,
        // and if that's the case we force Flickity to resize

        if (window.ResizeObserver && this.flickityInstance) {
            this.resizeObserver = new ResizeObserver(() => {
                this.flickityInstance.resize();
            });

            this.dom.main.querySelectorAll('.product-item').forEach((item) => {
                this.resizeObserver.observe(item);
            });
        }

        this.dom.main.style.height = 'auto'
    }

    Search() {

        const clerkSearchSetup = this.clerkSettings;
        window.Clerk("call", clerkSearchSetup.endpoint, clerkSearchSetup, async (data) => {

            if (data.product_data && data.product_data.length) {
                this.data = data;
                return this.Init();
            }
            else {
                this.data = null;
                return this.Init();
            }
        },
            function(response) {
                console.error(response);
            }
        );
    }
}



const initClerkSliders = () => {

    const clerkSliders = document.querySelectorAll('[data-section-type="clerk-slider"]');
    clerkSliders.forEach(clerkSlider => {
        new ClerkSlider({ main: clerkSlider });
    });
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initClerkSliders();
} else {
    document.addEventListener('DOMContentLoaded', () => initClerkSliders(), {
        once: true,
    });
}